import { render, staticRenderFns } from "./inActiveHospital.vue?vue&type=template&id=78cff970&scoped=true"
import script from "./inActiveHospital.vue?vue&type=script&lang=js"
export * from "./inActiveHospital.vue?vue&type=script&lang=js"
import style0 from "./inActiveHospital.vue?vue&type=style&index=0&id=78cff970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cff970",
  null
  
)

export default component.exports